import * as yup from 'yup'
import { REQUIRED_FIELD } from './../constants'

export default yup.object({
  acceptDataUsages: yup.boolean().oneOf([true], REQUIRED_FIELD),
})



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/SubmitSchema.js